export default "__VITE_ASSET__8bb45202__"